import { useState } from "react"
import { Angle } from "./Angle"
import { Hem } from "./Hem"
import { Fabric } from "./Fabric"
import { toggleXRButtonVisibility } from "../3D/setup"

export function Menu() {
	const iconSrc = "assets/CustomisePencil.svg"
	const iconBackSrc = "assets/CustomiseBack.svg"
	const [isVisible, setIsVisible] = useState(false)

	// Function to toggle visibility
	const toggleVisibility = () => {
		setIsVisible(!isVisible)
	}

	const CustomiseButton = () => (
		<button id="customiseButton" onClick={toggleVisibility}>
			Customise
			<img
				src={iconSrc}
				alt="Top Toggle Icon"
				className="customiseButtonIcon"
			/>
		</button>
	)

	const BackButton = () => (
		<button id="customiseBackButton" onClick={toggleVisibility}>
			<img
				src={iconBackSrc}
				alt="Top Toggle Icon"
				className="customiseBackButtonIcon"
			/>
		</button>
	)

	const Items = () => (
		<section className="accordion accordion--radio">
			<Fabric />
			<Hem />
			<Angle />
		</section>
	)
	toggleXRButtonVisibility()
	return (
		<>
			<div id="customisation">{!isVisible && <CustomiseButton />}</div>
			{isVisible && (
				<div id="customisationPopUp">
					<BackButton />
					<Items />
				</div>
			)}
		</>
	)
}
